import { memoSanitize } from '@axa-asia/emma-safely-set-inner-html';
import React, { Component } from 'react';
import { t } from '../../locales';
import './styles.scss';
import loadingImg from './loading.png';

interface LongLoadingViewProps {
  isShowText: boolean;
}

interface LongLoadingViewState {}

export default class LongLoadingView extends Component<
  LongLoadingViewProps,
  LongLoadingViewState
> {
  static defaultProps = {
    isShowText: false,
  };

  constructor(props: LongLoadingViewProps) {
    super(props);
    this.state = {};
  }

  render() {
    const { isShowText } = this.props;
    return (
      <div className="long-loading-view">
        <div className="long-loading-view-wrap">
          <div className="long-loading-img">
            <img src={loadingImg} alt="" />
          </div>
          {isShowText && (
            <div
              className="long-loading-text"
              dangerouslySetInnerHTML={{
                __html: memoSanitize(t('LONG_LOADING_TEXT')),
              }}
            ></div>
          )}
        </div>
      </div>
    );
  }
}
